{{#if (not subclasses.length)}}
cg = new();
{{/if}}
